module.exports = __webpack_public_path__ + "static/media/StrategicPlan2021.b3dd471b.pdf";